
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { IAchievement } from "../../data";
import { useInView } from "../../hooks";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHeader from "../common/SectionHeader";
import AchievementCard from "../common/AchievementCard";
import styles from "../../assets/style.module.css";

export interface RecentAchievementsProps {
    basePath: string;
    achievements: IAchievement[];
}

function RecentAchievements({ basePath, achievements }: RecentAchievementsProps) {

    const [ref, inView] = useInView();
    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!achievements.length) return null;

    return (<section className={Classname.build(styles["section"], styles["section-dark"])}>
        <div className={styles["container"]}>
            <SectionHeader eyebrow={labels.achievements_eyebrow} title={labels.achievements_title} titleEm={labels.achievements_title_em}
                action={<Btn variant="ghost" size="sm" to={{ pathname: pagePath(basePath, "ACHIEVEMENTS"), search: searchParams.toString() }}>{labels.view_achievements} <i className="fa fa-arrow-right" /></Btn>} />
            <div ref={ref} className={styles["honours"]}>
                {achievements.map((a, i) => (<AchievementCard key={a.title} achievement={a} index={i} visible={inView} />))}
            </div>
        </div>
    </section>);
}

export default RecentAchievements;
